import { useDispatch, useSelector } from 'hooks/store';
import { createAlertNotification } from 'infra/notification';
import {
  AlertNotification,
  AlertNotificationType,
  setNotificationAction,
  notificationSelector,
  clearNotificationAction,
} from 'state/slices/notification';

interface NotificationHandler {
  push(message: string, options?: {
    type?: AlertNotificationType;
  }): void;
  get(): AlertNotification | undefined;
  clear(): void;
}

export const useNotifications = (): NotificationHandler => {
  const dispatch = useDispatch();
  const currentNotification = useSelector(notificationSelector);

  const push = (message: string, options?: {
    type?: AlertNotificationType;
  }) => {
    const notification = createAlertNotification(message, options?.type);
    dispatch(setNotificationAction(notification));
  };
  const get = (): AlertNotification | undefined => currentNotification;
  const clear = () => {
    dispatch(clearNotificationAction());
  };
  return {
    push,
    get,
    clear,
  };
};
